import DurationService from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

type WorldwideOverviewParams = {
    country: number | string;
    key: string;
    duration: string;
    isWWW?: string;
};

export const buildAdNetworksRequestParams = (params: WorldwideOverviewParams, options: { pageSize?: number } = {}) => {
    const { country, key, duration, isWWW } = params;
    const { from, to, isWindow } = DurationService.getDurationData(duration).forAPI;
    const is28d = duration === "28d";

    return {
        country,
        from,
        to,
        isWindow,
        keys: key,
        includeSubDomains: isWWW === "*",
        timeGranularity: is28d ? ("Daily" as const) : ("Monthly" as const),
        webSource: devicesTypes.DESKTOP,
        orderBy: "Share desc",
        ...(options.pageSize ? { pageSize: options.pageSize } : {}),
    };
};
